export const dummyAsins = [
  'B0745YCTGD',
  'B076429P3D',
  'B08NXZ8LRG',
  'B07Y5LQ97W',
  'B07Y5KCT8G',
  'B08NY2WKSR',
  'B091GV8P2J',
  'B083P1Z51P',
  'B097P2FMSY',
  'B07VNTLN62',
  'B07VLP4C1Z',
  'B0BD9WM7JZ',
  'B0BD9WM3K9',
  'B0BDBJNN5J',
  'B0BD9G122R',
  'B0BD9FG7VW',
  'B0767SY5K8',
  'B07DG2DV8N',
  'B0BGSYVTBK',
  'B09QBK8FKB',
  'B0BJSB4KWL',
  'B08MFPZWF9',
  'B09H5DK777',
  'B09MRJL1NG',
  'B08MJYFBBV',
  'B08MDF25P2',
  'B08KSN6G69',
  'B081KMGDMQ',
  'B07P3NC5PQ',
  'B07KCXPF4R',
  'B084HGSDNK',
  'B09BG9RDDP',
];
